<template>
  <div>
    <b-row>
      <b-col>
        <form-wizard ref="formWizard" @on-complete="onSubmit" color="#1C4862" errorColor="#c1272d">
          <div slot="title"></div>
          <tab-content title="รายละเอียดงาน" icon="ti-user" :before-change="validateFirstTab">
            <b-row>
              <b-col>
                <b-card title="รายละเอียดงาน">
                  <b-row>
                    <b-col sm="12" md="6" lg="4">
                      <TextInput
                        :value="$v.form.title"
                        id="title"
                        feedback
                        label="ชื่องาน (ใช้ภายใน)"
                        placeholder
                        :isRequired="false"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <TextInput
                        :value="$v.form.customerJobId"
                        id="customerJobId"
                        feedback
                        label="เลขที่งาน (ใช้ภายใน)"
                        placeholder
                        :isRequired="false"
                      />
                    </b-col>
                    <!-- <b-col sm="12" md="6" lg="4">
                      <SelectInput
                        v-if="!update"
                        :value="$v.form.status"
                        id="jobType"
                        feedback="จำเป็นต้องเลือก"
                        label="สถานะงาน"
                        :options="statusOptions"
                        :isRequired="true"
                      />
                      <SelectInput
                        v-else
                        :value="$v.form.status"
                        id="jobType"
                        feedback="จำเป็นต้องเลือก"
                        label="สถานะงาน"
                        :options="statusForUpdateOptions"
                        :isRequired="true"
                      />
                    </b-col>-->
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="6" lg="4">
                      <b-form-group>
                        <label for="startDate">
                          วันที่เริ่มงาน
                          <span class="text-danger">*</span>
                        </label>
                        <date-picker
                          v-model="$v.startDate.$model"
                          :config="dateOptions"
                          :state="$v.startDate.$dirty ? !$v.startDate.$error && startDateOk : null"
                          :aria-describedby="'startDate-live-feedback'"
                        ></date-picker>
                        <b-form-invalid-feedback :id="'startDate-live-feedback'">
                          <span v-if="update">ไม่สามารถเลือกเวลาก่อนเวลาเดิม</span>
                          <span v-else>ไม่สามารถเลือกเวลาก่อนเวลาปัจจุบัน</span>
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <SelectInput
                        :value="$v.form.jobType"
                        id="jobType"
                        feedback="จำเป็นต้องเลือก"
                        label="ลักษณะงาน"
                        :options="jobTypeOptions"
                        :isRequired="true"
                      />
                    </b-col>
                    <b-col v-if="form.jobType === 'งานประจำ'" sm="12" md="6" lg="4">
                      <b-form-group>
                        <label for="period">ระยะเวลางาน</label>
                        <b-input-group>
                          <b-form-input
                            v-model="$v.form.period.$model"
                            type="text"
                            id="period"
                            placeholder
                            :state="$v.form.period.$dirty ? !$v.form.period.$error : null"
                            aria-describedby="period-live-feedback"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-group>
                              <b-form-select
                                v-model="$v.form.periodUnit.$model"
                                :options="periodUnitOptions"
                                :state="$v.form.periodUnit.$dirty ? !$v.form.periodUnit.$error : null"
                                aria-describedby="periodUnit-live-feedback"
                              ></b-form-select>
                              <b-form-invalid-feedback id="periodUnit-live-feedback">เลือกหน่วย</b-form-invalid-feedback>
                            </b-form-group>
                          </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback id="period-live-feedback">ตัวเลขเท่านั้น</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="6" lg="4">
                      <TextInput
                        :value="$v.form.contactName"
                        id="contactName"
                        feedback="จำเป็นต้องระบุ"
                        label="ชื่อผู้ติดต่อ"
                        placeholder
                        :isRequired="true"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <TextInput
                        :value="$v.form.contactNumber"
                        id="contactNumber"
                        feedback="จำเป็นต้องระบุ"
                        label="เบอร์โทรผู้ติดต่อ"
                        placeholder
                        :isRequired="true"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                      <TextInput
                        :value="$v.form.contactEmail"
                        id="contactEmail"
                        feedback="ระบุอีเมล"
                        label="อีเมลผู้ติดต่อ"
                        placeholder
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card title="รายละเอียดรถ">
                  <b-row>
                    <b-col
                      sm="12"
                      md="4"
                      v-for="truckCat in truckTypeRender"
                      :key="truckCat.category"
                    >
                      <b-form-group>
                        <template slot="label">
                          <b-form-checkbox
                            v-model="truckCat.allSelected"
                            :indeterminate="truckCat.indeterminate"
                            aria-describedby="truckCat.options"
                            aria-controls="truckCat.options"
                            @change="toggleAll($event, truckCat.options)"
                          >{{ truckCat.category }}</b-form-checkbox>
                        </template>
                        <b-form-checkbox-group
                          :id="'option' + truckCat.category"
                          v-model="$v.form.truckType.$model"
                          class="ml-4"
                          aria-label="Individual truckType"
                          stacked
                          :state="$v.form.truckType.$dirty ? !$v.form.truckType.$error : null"
                        >
                          <b-form-checkbox
                            v-for="(option, index) in truckCat.options"
                            v-bind:key="index"
                            :value="option.value"
                          >
                            {{ option.text }}
                            <span align-self="center">
                              <img
                                class="logisty-icon"
                                :id="'truck-icon-' + option.value"
                                src="/img/icon/icon_eye.png"
                              />
                            </span>
                            <b-popover
                              :target="'truck-icon-' + option.value"
                              placement="auto"
                              triggers="hover focus"
                            >
                              <b-img :src="'/img/truck_icon/' + option.icon" height="150"></b-img>
                            </b-popover>
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="mb-2 ml-4">
                      <span
                        class="logisty-custom-invalid-feedbace"
                        v-if="$v.form.truckType.$error"
                      >เลือกชนิดรถอย่างน้อย 1 ชนิด</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <!-- <b-col sm="12" md="6">
                      <b-form-group>
                        <label for="truckNum">จำนวนรถที่ต้องการ</label>
                        <b-input-group>
                          <b-form-input
                            v-model="$v.form.truckNum.$model"
                            type="text"
                            id="truckNum"
                            placeholder
                            :state="$v.form.truckNum.$dirty ? !$v.form.truckNum.$error : null"
                            aria-describedby="truckNum-live-feedback"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-input-group-text>คัน</b-input-group-text>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="truckNum-live-feedback">ตัวเลขเท่านั้น</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                    <b-col sm="12" md="6">
                      <b-form-group>
                        <label for="frequency">
                          ความถี่
                          <span class="text-danger">*</span>
                        </label>
                        <b-input-group>
                          <b-form-input
                            v-model="$v.form.frequency.$model"
                            type="text"
                            id="frequency"
                            placeholder
                            :state="$v.form.frequency.$dirty ? !$v.form.frequency.$error : null"
                            aria-describedby="frequency-live-feedback"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-group>
                              <b-form-select
                                v-model="$v.form.frequencyType.$model"
                                :options="frequencyTypeOptions"
                                :state="$v.form.frequencyType.$dirty ? !$v.form.frequencyType.$error : null"
                                aria-describedby="frequencyType-live-feedback"
                              ></b-form-select>
                              <!-- <b-form-invalid-feedback id="frequencyType-live-feedback">เลือกประเภท</b-form-invalid-feedback> -->
                            </b-form-group>
                          </b-input-group-append>
                          <b-form-invalid-feedback id="frequency-live-feedback">ตัวเลขเท่านั้น</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.specialRequirement"
                        id="specialRequirement"
                        feedback
                        label="ข้อกำหนดพิเศษ"
                        placeholder="ตัวอย่าง : ประตูต้องสูง 2 ม. , ต้องมีโซ่ไว้ล่ามสินค้า , ต้องมีไม้หมอนรองสินค้า, สามารถวิ่งทำรอบได้วันละ 2 เที่ยว"
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="truckCargoInsuranceCoverage">ประกันสินค้าที่ต้องการ</label>
                        <b-input-group>
                          <b-form-input
                            v-model="$v.form.truckCargoInsuranceCoverage.$model"
                            type="text"
                            id="truckCargoInsuranceCoverage"
                            placeholder="ตัวอย่าง : 1000000"
                            :state="$v.form.truckCargoInsuranceCoverage.$dirty ? !$v.form.truckCargoInsuranceCoverage.$error : null"
                            aria-describedby="truckCargoInsuranceCoverage-live-feedback"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-input-group-text>บาท ขึ้นไป</b-input-group-text>
                          </b-input-group-append>
                          <b-form-invalid-feedback
                            id="truckCargoInsuranceCoverage-live-feedback"
                          >ระบุตัวเลข</b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- <b-row class="mb-2">
                    <b-col sm="12" md="12">
                      <b-form-group>
                        <label for="origin">
                          ต้นทาง
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-checkbox-group
                          id="origin"
                          v-model="$v.origin.$model"
                          :options="regionOptions"
                          :state="$v.origin.$dirty ? !$v.origin.$error : null"
                          aria-describedby="origin-live-feedback"
                        ></b-form-checkbox-group>
                        <b-form-invalid-feedback
                          id="origin-live-feedback"
                          :state="$v.origin.$dirty ? !$v.origin.$error : null"
                        >เลือกอย่างน้อย 1</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="12">
                      <b-form-group>
                        <label for="destination">
                          ปลายทาง
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-checkbox-group
                          id="destination"
                          v-model="$v.destination.$model"
                          :options="regionOptions"
                          :state="$v.destination.$dirty ? !$v.destination.$error : null"
                          aria-describedby="destination-live-feedback"
                        ></b-form-checkbox-group>
                        <b-form-invalid-feedback
                          id="destination-live-feedback"
                          :state="$v.destination.$dirty ? !$v.destination.$error : null"
                        >เลือกอย่างน้อย 1</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-row>-->
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card title="รายละเอียดสินค้า">
                  <b-row>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.goodsDescriptions"
                        id="goodsDescriptions"
                        feedback="ต้องระบุ"
                        label="ชื่อสินค้า"
                        placeholder="ตัวอย่าง : เหล็กเส้น น้ำมันพืช อาหารแช่แข็ง"
                        :isRequired="true"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" md="4">
                      <b-form-group>
                        <label for="totalGoodsWeight">น้ำหนักสินค้า</label>
                        <b-input-group>
                          <b-form-input
                            v-model="$v.form.totalGoodsWeight.$model"
                            type="text"
                            id="totalGoodsWeight"
                            placeholder
                            :state="$v.form.totalGoodsWeight.$dirty ? !$v.form.totalGoodsWeight.$error : null"
                            aria-describedby="totalGoodsWeight-live-feedback"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-form-group>
                              <b-form-select
                                v-model="$v.form.totalGoodsWeightUnit.$model"
                                :options="totalGoodsWeightUnitOptions"
                                :state="$v.form.totalGoodsWeightUnit.$dirty ? !$v.form.totalGoodsWeightUnit.$error : null"
                                aria-describedby="totalGoodsWeightUnit-live-feedback"
                              ></b-form-select>
                              <b-form-invalid-feedback
                                id="totalGoodsWeightUnit-live-feedback"
                              >เลือกหน่วย</b-form-invalid-feedback>
                            </b-form-group>
                          </b-input-group-append>
                        </b-input-group>
                        <b-form-invalid-feedback id="totalGoodsWeight-live-feedback">ตัวเลขเท่านั้น</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                      <TextInput
                        :value="$v.form.maxOriginNumber"
                        id="maxOriginNumber"
                        feedback="ระบุตัวเลข"
                        label="จำนวนจุดขึ้นต่อเที่ยว"
                        placeholder="ตัวอย่าง : 3"
                        :isRequired="false"
                      />
                    </b-col>
                    <b-col sm="12" md="4">
                      <TextInput
                        :value="$v.form.maxDestinationNumber"
                        id="maxDestinationNumber"
                        feedback="ระบุตัวเลข"
                        label="จำนวนจุดลงต่อเที่ยว"
                        placeholder="ตัวอย่าง : 3"
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card title="การเงิน">
                  <b-row>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.paymentDetails"
                        id="paymentDetails"
                        feedback="ต้องระบุ"
                        label="รูปแบบการจ่ายเงิน"
                        placeholder="ตัวอย่าง : เครดิต 30 วัน จ่ายทุกๆวันที่ 15 ของเดือน"
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-card title="อื่นๆ">
                  <b-row>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.remark"
                        id="remark"
                        feedback
                        label="หมายเหตุอื่น ๆ"
                        placeholder
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content
            title="สถานที่ขึ้น / ลง สินค้า"
            icon="ti-settings"
            :before-change="validateSecondTab"
          >
            <b-row>
              <b-col>
                <b-card title="สถานที่ขึ้น / ลง สินค้า">
                  <b-row class="mb-2">
                    <b-col sm="12" md="12">
                      <b-form-group>
                        <label for="origin">
                          ต้นทาง
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-checkbox-group
                          id="origin"
                          v-model="$v.origin.$model"
                          :options="regionOptions"
                          :state="$v.origin.$dirty ? !$v.origin.$error : null"
                          aria-describedby="origin-live-feedback"
                        ></b-form-checkbox-group>
                        <b-form-invalid-feedback
                          id="origin-live-feedback"
                          :state="$v.origin.$dirty ? !$v.origin.$error : null"
                        >เลือกอย่างน้อย 1</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.originPlace"
                        id="originPlace"
                        feedback
                        label="ระบุ สถานที่ / อำเภอ / จังหวัด (ไม่บังคับกรอก)"
                        placeholder="เช่น อ.เมือง จ.ระยอง, นิคมอุตสาหกรรมลำพูน จ.ลำพูน เป็นต้น"
                        :isRequired="false"
                      />
                    </b-col>
                    <b-col sm="12" md="12">
                      <b-form-group>
                        <label for="destination">
                          ปลายทาง
                          <span class="text-danger">*</span>
                        </label>
                        <b-form-checkbox-group
                          id="destination"
                          v-model="$v.destination.$model"
                          :options="regionOptions"
                          :state="$v.destination.$dirty ? !$v.destination.$error : null"
                          aria-describedby="destination-live-feedback"
                        ></b-form-checkbox-group>
                        <b-form-invalid-feedback
                          id="destination-live-feedback"
                          :state="$v.destination.$dirty ? !$v.destination.$error : null"
                        >เลือกอย่างน้อย 1</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.destinationPlace"
                        id="destinationPlace"
                        feedback
                        label="ระบุ สถานที่ / อำเภอ / จังหวัด (ไม่บังคับกรอก)"
                        placeholder="เช่น อ.เมือง จ.ระยอง, นิคมอุตสาหกรรมลำพูน จ.ลำพูน เป็นต้น"
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <TextInput
                        :value="$v.form.loadingDetails"
                        id="loadingDetails"
                        feedback
                        label="การโหลดสินค้า ขึ้น/ลง"
                        placeholder="ตัวอย่าง : ขาขึ้นโรงงานขึ้นให้ ขาลงต้องการคนลงสินค้าขั้นต่ำ 2 คน"
                        :isRequired="false"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
            <b-row v-if="!update">
              <b-col>
                <b-card title="เอกสาร">
                  <UploadFile
                    ref="quoteFileUpload"
                    docType="shipper-quote"
                    :queueOption="false"
                    refId="quoteFileUpload"
                    :keepCompleted="true"
                    :showHeader="false"
                    :forJobCreate="true"
                  />
                </b-card>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content
            title="ตัวเลือกการประกาศ"
            icon="ti-settings"
            :before-change="validatePrivateTab"
          >
            <b-card>
              <div v-if="!update">
                <PrivateForm ref="privateJobForm" />
              </div>
              <div v-else>
                <PrivateForm
                  v-if="loadReady"
                  ref="privateJobForm"
                  :updateAction="true"
                  :propJobPrivate="quote.private"
                  :propVendorGroup="quote.vendorGroup.map(x => x._id)"
                  :propCompanySelected="quote.companyList.map(x => x._id)"
                  :propCompanyExcuted="quote.companyExcluded"
                />
              </div>
            </b-card>
          </tab-content>
          <b-button variant="primary" slot="next">ถัดไป</b-button>
          <b-button variant="success" slot="finish">{{ update ? 'บันทึก' : 'ประกาศงาน' }}</b-button>
          <b-button variant="warning" slot="prev">ย้อนกลับ</b-button>
        </form-wizard>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import TextInput from '../../components/TextInput'
import SelectInput from '../../components/SelectInput'
import MultiSelectTag from '../../components/MultiSelectTag'
import UploadFile from '../../components/UploadFile'
import PrivateForm from './PrivateJobForm'
import ModalLoading from '../../components/ModalLoading'

import TruckType from '../../services/http/TruckType'
import Quote from '../../services/http/Quote'

import { validationMixin } from 'vuelidate'
import { required, requiredIf, decimal, helpers, url, numeric, email } from 'vuelidate/lib/validators'

import datePicker from '../../components/LogistyDatePicker/DatePicker'

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

export default {
  props: {
    update: {
      type: Boolean,
      default: null,
      required: false
    }
  },
  mixins: [validationMixin],
  components: {
    TextInput,
    SelectInput,
    datePicker,
    MultiSelectTag,
    UploadFile,
    PrivateForm,
    ModalLoading,
    FormWizard,
    TabContent
  },
  validations () {
    if (this.tabIndex === 0) {
      return {
        form: {
          customerJobId: {

          },
          title: {

          },
          jobType: {
            required
          },
          status: {
            required
          },
          period: {
            required: requiredIf(function () {
              return this.form.jobType === 'งานประจำ'
            }),
            numeric
          },
          periodUnit: {
            required: requiredIf(function () {
              return this.form.period > 0
            })
          },
          frequency: {
            required,
            numeric
          },
          frequencyType: {
            required
          },
          truckNum: {
            numeric
          },
          truckType: {
            required
          },
          specialRequirement: {

          },
          truckCargoInsuranceCoverage: {
            numeric
          },
          loadingDetails: {

          },
          goodsDescriptions: {
            required
          },
          totalGoodsWeight: {
            decimal
          },
          totalGoodsWeightUnit: {
            required: requiredIf(function () {
              return this.form.totalGoodsWeight > 0
            })
          },
          maxOriginNumber: {
            numeric
          },
          maxDestinationNumber: {
            numeric
          },
          paymentDetails: {

          },
          remark: {

          },
          contactName: {
            required
          },
          contactNumber: {
            required
          },
          contactEmail: {
            email
          },
          originPlace: {

          },
          destinationPlace: {

          }
        },
        origin: {

        },
        destination: {

        },

        startDate: {
          required
        }
      }
    } else if (this.tabIndex === 1) {
      return {
        form: {
          customerJobId: {

          },
          title: {

          },
          jobType: {
            required
          },
          status: {
            required
          },
          period: {
            required: requiredIf(function () {
              return this.form.jobType === 'งานประจำ'
            }),
            numeric
          },
          periodUnit: {
            required: requiredIf(function () {
              return this.form.period > 0
            })
          },
          frequency: {
            required,
            numeric
          },
          frequencyType: {
            required
          },
          truckNum: {
            numeric
          },
          truckType: {
            required
          },
          specialRequirement: {

          },
          truckCargoInsuranceCoverage: {
            numeric
          },
          loadingDetails: {

          },
          goodsDescriptions: {
            required
          },
          totalGoodsWeight: {
            decimal
          },
          totalGoodsWeightUnit: {
            required: requiredIf(function () {
              return this.form.totalGoodsWeight > 0
            })
          },
          maxOriginNumber: {
            numeric
          },
          maxDestinationNumber: {
            numeric
          },
          paymentDetails: {

          },
          remark: {

          },
          contactName: {
            required
          },
          contactNumber: {
            required
          },
          contactEmail: {
            email
          },
          originPlace: {

          },
          destinationPlace: {

          }
        },
        origin: {
          required
        },
        destination: {
          required
        },
        startDate: {
          required
        }
      }
    } else {
      return {}
    }
  },
  data () {
    return {
      form: {
        customerJobId: null,
        title: null,
        jobType: null,
        period: null,
        frequency: null,
        frequencyType: 'เที่ยว/วัน',
        periodUnit: null,
        contactName: null,
        contactEmail: null,
        contactNumber: null,
        truckNum: null,
        truckType: [],
        specialRequirement: null,
        truckCargoInsuranceCoverage: null,
        loadingDetails: null,
        origin: [],
        destination: [],
        goodsDescriptions: null,
        totalGoodsWeight: null,
        totalGoodsWeightUnit: null,
        maxOriginNumber: null,
        maxDestinationNumber: null,
        paymentDetails: null,
        remark: null,
        status: 5,
        originPlace: null,
        destinationPlace: null
      },
      startDate: null,
      origin: [],
      destination: [],
      jobTypeOptions: [
        { value: 'งานครั้งเดียว', text: 'งานครั้งเดียว' },
        { value: 'งานประจำ', text: 'งานประจำ' }
      ],
      dateOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: true
      },
      periodUnitOptions: [
        { value: null, text: 'ไม่ระบุ' },
        { value: 'วัน', text: 'วัน' },
        { value: 'สัปดาห์', text: 'สัปดาห์' },
        { value: 'เดือน', text: 'เดือน' },
        { value: 'ปี', text: 'ปี' }
      ],
      frequencyTypeOptions: [
        { value: 'เที่ยว/วัน', text: 'เที่ยว/วัน' },
        { value: 'เที่ยว/สัปดาห์', text: 'เที่ยว/สัปดาห์' },
        { value: 'เที่ยว/เดือน', text: 'เที่ยว/เดือน' }
      ],
      truckTypeRender: [],
      regionOptions: [
        { value: 'ภาคกลาง', text: 'ภาคกลาง' },
        { value: 'ภาคเหนือ', text: 'ภาคเหนือ' },
        { value: 'ภาคตะวันออก', text: 'ภาคตะวันออก' },
        { value: 'ภาคตะวันออกเฉียงเหนือ', text: 'ภาคตะวันออกเฉียงเหนือ' },
        { value: 'ภาคใต้', text: 'ภาคใต้' },
        { value: 'ภาคตะวันตก', text: 'ภาคตะวันตก' }
      ],
      totalGoodsWeightUnitOptions: [
        { value: null, text: 'ไม่ระบุ' },
        { value: 'ตัน', text: 'ตัน' },
        { value: 'กิโลกรัม', text: 'กิโลกรัม' }
      ],
      statusOptions: [
        { value: 0, text: 'ร่าง' },
        { value: 5, text: 'เผยแพร่' }
      ],
      statusForUpdateOptions: [
        { value: 0, text: 'ร่าง' },
        { value: 5, text: 'เผยแพร่' },
        { value: 20, text: 'ปิดงาน' }
      ],
      step: 0,
      haveFileUploaded: false,
      jobId: null,
      quote: null,
      loadReady: false,
      startDateOk: true,
      oldStartDate: null,
      tabIndex: 0
    }
  },
  async mounted () {
    Window.Event.$on('saveQuoteForm', this.onSubmit)
    Window.Event.$on('quoteTabNext', this.next)
    Window.Event.$on('quoteTabBack', this.goBack)
    // watch dropzone complete
    this.$watch(
      '$refs.quoteFileUpload.complete',
      (new_value, old_value) => {
        if (new_value) {
          // alert('สร้างใบขอราคาและเอกสารสำเร็จ')
          this.$bvModal.msgBoxOk('ประกาศงานสำเร็จ', this.$getConst('okModalClass'))
            .then(() => {
              Window.Event.$emit('closeModalLoading')
              this.$router.push({
                name: 'รายละเอียดใบขอราคาของฉัน',
                params: {
                  jobId: this.jobId
                }
              })
            })
        }
      }
    )
    // watch uploaded file num
    this.$watch(
      '$refs.quoteFileUpload.fileNum',
      (new_value, old_value) => {
        if (new_value > 0) {
          this.haveFileUploaded = true
        } else {
          this.haveFileUploaded = false
        }
      }
    )
    // prepare trucktype
    var truckType = new TruckType()
    var truckTypeData = await truckType.getAllTruckType()
    var truckCats = [...new Set(truckTypeData.data.map(x => x.category))]
    var truckTypeRender = []
    for (var i = 0; i < truckCats.length; i++) {
      var data = []

      for (var j = 0; j < truckTypeData.data.length; j++) {
        if (truckTypeData.data[j].category == truckCats[i]) {
          data.push({
            text: truckTypeData.data[j].typeName,
            value: truckTypeData.data[j]._id,
            icon: truckTypeData.data[j].icon
          })
        }
      }

      truckTypeRender.push(
        {
          category: truckCats[i],
          options: data,
          allSelected: false,
          indeterminate: false
        }
      )

      // truckTypeRender.unshift(truckTypeRender.slice(1,1))
    }
    var removed = truckTypeRender.slice(1, 3)

    truckTypeRender.splice(1, 2)

    this.truckTypeRender = removed.concat(truckTypeRender)

    // load data for update
    if (this.update) {
      var quote = new Quote()
      var data = {
        qrJobId: this.$route.params.jobId
      }
      var result = await quote.shipperGetOneQuote(data)
      if (result.code === 1) {
        var loaded = result.data
        this.quote = loaded

        this.form.customerJobId = loaded.customerJobId
        this.form.title = loaded.title
        this.form.jobType = loaded.jobType
        this.form.period = loaded.period
        this.form.frequency = loaded.frequency
        this.form.frequencyType = loaded.frequencyType
        this.form.periodUnit = loaded.periodUnit
        this.form.truckNum = loaded.truckNum
        this.form.truckType = loaded.truckType
        this.form.specialRequirement = loaded.specialRequirement
        this.form.truckCargoInsuranceCoverage = loaded.truckCargoInsuranceCoverage
        this.form.goodsDescriptions = loaded.goodsDescriptions
        this.form.totalGoodsWeight = loaded.totalGoodsWeight
        this.form.totalGoodsWeightUnit = loaded.totalGoodsWeightUnit
        this.form.maxOriginNumber = loaded.maxOriginNumber
        this.form.maxDestinationNumber = loaded.maxDestinationNumber
        this.form.paymentDetails = loaded.paymentDetails
        this.form.remark = loaded.remark
        this.form.loadingDetails = loaded.loadingDetails
        // this.form.status = loaded.status
        this.form.contactName = loaded.contactName
        this.form.contactNumber = loaded.contactNumber
        this.form.contactEmail = loaded.contactEmail
        this.startDate = this.$moment(loaded.startDate).format('YYYY/MM/DD')
        this.origin = loaded.origin.map((x) => {
          return x.region
        })
        this.destination = loaded.destination.map((x) => {
          return x.region
        })

        this.oldStartDate = this.startDate
        this.form.originPlace = loaded.originPlace
        this.form.destinationPlace = loaded.destinationPlace

        this.loadReady = true
      } else if (result.code === 110) {
        await this.$bvModal.msgBoxOk('ไม่มีสิทธิ์ในการแก้ไขงานนี้', this.$getConst('okModalClass'))
        this.$router.push({ name: 'ใบขอราคาทั้งหมด', params: { tabName: 'all' } })
      } else {
        await this.$bvModal.msgBoxOk('ไม่สามารถโหลดข้อมูลงานได้', this.$getConst('okModalClass'))
        this.$router.push({ name: 'ใบขอราคาทั้งหมด', params: { tabName: 'all' } })
      }
    }
  },
  beforeDestroy () {
    Window.Event.$off('saveQuoteForm')
    Window.Event.$off('quoteTabNext')
    Window.Event.$off('quoteTabBack')
  },
  methods: {
    toggleAll (checked, options) {
      if (checked) {
        for (var i = 0; i < options.length; i++) {
          if (this.form.truckType.indexOf(options[i].value) === -1) {
            this.form.truckType.push(options[i].value)
          }
        }
      } else {
        for (var i = 0; i < options.length; i++) {
          if (this.form.truckType.indexOf(options[i].value) !== -1) {
            this.form.truckType.splice(this.form.truckType.indexOf(options[i].value), 1)
          }
        }
      }
    },
    async onSubmit () {
      this.$v.$touch()

      if (this.$v.$anyError) {
        this.step = 0
        return
      }

      // check value from child component about private job parameter
      if (this.$refs.privateJobForm.jobPrivate === true) {
        if (this.$refs.privateJobForm.vendorGroup.length < 1) {
          console.log('private job data error')
          return
        }
      } else if (this.$refs.privateJobForm.jobPrivate === false) {

      } else {
        return
      }

      Window.Event.$emit('showModalLoading')
      // prepare startDate
      this.form.startDate = this.$moment(this.startDate).utc().format()
      // prepare origin
      this.form.origin = this.origin.map((x) => {
        return { region: x }
      })
      // prepare destination
      this.form.destination = this.destination.map((x) => {
        return { region: x }
      })
      // prepare private vendor
      this.form.private = this.$refs.privateJobForm.jobPrivate
      this.form.vendorGroup = this.$refs.privateJobForm.vendorGroup
      this.form.companyExcluded = this.$refs.privateJobForm.companyExcluded

      var quote = new Quote()
      try {
        if (!this.update) {
          // do create
          let result = await quote.shipperCreate(this.form)
          if (result.code === 1) {
            // console.log(result)
            this.jobId = result.data._id

            window.analytics.track('success-create-quote', {
              jobId: this.jobId
            })
            // do upload doc if exist
            if (this.haveFileUploaded) {
              Window.Event.$emit('doUploadQueue-shipper-quote', result.data._id)
            } else {
              await this.$bvModal.msgBoxOk('ประกาศงานสำเร็จ', this.$getConst('okModalClass'))
              Window.Event.$emit('closeModalLoading')
              this.$router.push({
                name: 'รายละเอียดใบขอราคาของฉัน',
                params: {
                  jobId: this.jobId
                }
              })
            }
          } else {
            await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
            Window.Event.$emit('closeModalLoading')
          }
        } else {
          // do update
          this.form.qrJobId = this.quote._id
          let result = await quote.shipperUpdateQuote(this.form)

          if (result.code === 1) {
            // console.log(result)
            this.jobId = result.data._id

            window.analytics.track('success-update-quote', {
              jobId: this.jobId
            })
            await this.$bvModal.msgBoxOk('แก้ไขประกาศงานสำเร็จ', this.$getConst('okModalClass'))
            Window.Event.$emit('closeModalLoading')
            this.$router.push({
              name: 'รายละเอียดใบขอราคาของฉัน',
              params: {
                jobId: this.jobId
              }
            })
          } else {
            await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
            Window.Event.$emit('closeModalLoading')
          }
        }
      } catch (error) {
        console.log(error)
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        Window.Event.$emit('closeModalLoading')
      }
    },
    next () {
      this.step = 1
    },
    goBack () {
      this.step = 0
    },
    validateFirstTab: function () {
      this.tabIndex = this.$refs.formWizard.activeTabIndex
      this.$v.$touch()
      if (this.$v.$anyError || !this.startDateOk) {
        this.makeToast('warning', 'คำเตือน', 'กรุณาระบุข้อมูลสำคัญให้ครบถ้วน')
        return false
      } else {
        this.$v.$reset()
        window.scrollTo(0, 0)
        return true
      }
    },
    validateSecondTab: function (idx) {
      this.tabIndex = this.$refs.formWizard.activeTabIndex
      this.$v.$touch()
      if (this.$v.$anyError || !this.startDateOk) {
        this.makeToast('warning', 'คำเตือน', 'กรุณาระบุข้อมูลสำคัญให้ครบถ้วน')
        return false
      } else {
        this.$v.$reset()
        window.scrollTo(0, 0)
        return true
      }
    },
    validatePrivateTab: function () {
      // return true
      if (this.$refs.privateJobForm.jobPrivate === true) {
        if (this.$refs.privateJobForm.vendorGroup.length < 1) {
          console.log('private job data error')
          this.makeToast('warning', 'คำเตือน', 'กรุณาระบุตัวเลือกประกาศงาน')
          return false
        } else {
          return true
        }
      } else if (this.$refs.privateJobForm.jobPrivate === false) {
        return true
      } else {
        this.makeToast('warning', 'คำเตือน', 'กรุณาระบุตัวเลือกประกาศงาน')
        return false
      }
    },
    makeToast (variant = 'success', title = '', content = '') {
      this.$bvToast.toast(content, {
        title: title,
        variant: variant,
        solid: true
      })
    }
  },
  watch: {
    startDate () {
      this.startDateOk = true

      if (this.update) {
        if (!this.$moment(this.startDate).isSameOrAfter(this.$moment(this.oldStartDate), 'day')) {
          this.startDateOk = false
        }
      } else {
        if (!this.$moment(this.startDate).isSameOrAfter(this.$moment(), 'day')) {
          this.startDateOk = false
        }
      }
    }
  }
}
</script>
